export function processingRef(content: TContent): TContent {
  return {
    ...content,
    parser_type: 'gutenberg_parser',
  };
}
